export default __webpack_public_path__ + "static/media/cvv.1a274868.jpg";